import { useLingui } from "@lingui/react/macro";

import { cn } from "@/utils/shadcn-ui";

import { optimizationColor } from "./gdmt";

export function GdmtScoreRing({
  score,
  max,
  size = 72,
}: {
  score: number;
  max: number;
  size?: number;
}) {
  const { t } = useLingui();
  const percent = max > 0 ? Math.min(1, Math.max(0, score / max)) : 0;
  const color = optimizationColor(Math.round(percent * 100));

  const strokeWidth = Math.max(3, Math.round(size * 0.1));
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="shrink-0"
      role="img"
      aria-label={t`GDMT score ${score} of ${max}`}
    >
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        className="stroke-muted-foreground/20"
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={`${circumference * percent} ${circumference}`}
        transform={`rotate(-90 ${center} ${center})`}
        className={cn(
          "transition-[stroke-dasharray] duration-500 motion-reduce:transition-none",
          color.stroke,
        )}
      />
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dominantBaseline="central"
        dy={-size * 0.04}
        className={cn("font-bold", color.fill)}
        style={{ fontSize: size * 0.36 }}
      >
        {score}
      </text>
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dominantBaseline="central"
        dy={size * 0.28}
        className="fill-muted-foreground"
        style={{ fontSize: size * 0.16 }}
      >
        /{max}
      </text>
    </svg>
  );
}
